import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  NgForm,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";

import { ApiLoginService } from "@app/api/api-login.service";
import { ApiContentService } from "@app/api/api-content.service";
import { ApiPartnerService } from "@app/api/api-partner.service";
import { LoadJsService } from "../../load-js/load-js.service";

declare const $: any; // Mendeklarasikan jQuery

@Component({
  selector: "app-adminnextsys-orderstb",
  templateUrl: "./adminnextsys-orderstb.component.html",
  styleUrls: ["./adminnextsys-orderstb.component.css"],
})
export class AdminNextsysOrderStbComponent implements OnInit {
  @ViewChild("fileUploader", { static: false })
  fileUploader: ElementRef;

  constructor(
    public restApi: ApiPartnerService,
    private fb: FormBuilder,
    private login: ApiLoginService,
    public partnerService: ApiPartnerService,
    public LoadJsOrder: LoadJsService,
    private router: Router
  ) { }

  formIdProduct = this.fb.group({
    productsource: [""],
  });
  formOrderstb = this.fb.group({
    partnerid: [""],
    noorder: [""],
    nogrf: [""],
    noiom: [""],
    sales_name: [""],
    quota: [""],
    ordertype: [3],
    orderdate: [""],
    packageid: [""],
    customer_phone: [""],
    ftthflag: [""],
    stbpurposeid: [""],
    launcherid: [""],
  });
  formProduct = this.fb.group({
    productid: [""],
    transactiontype: [""],
    note: [""],
    quota: [""],
  });

  btn_save = true;
  btn_loading = false;
  alert_failed = false;
  alert_success = false;
  alert_redirect = false;
  alert_quota = false;
  table_product_kosong = true;
  table_product_data = false;

  selectedProduct: any = [];
  data_launchers: any = [];
  data_stbpurpose: any = [];
  data_productsource: any = {};
  data_partner: any = [];
  data_products: any = [];
  response_api: any = {};
  partnerdetail: any = {};
  queryParams = '';

  count: number = 0;
  sum: number = 0;

  ordertypeValue = "";

  ngOnInit() {
    this.LoadJsOrder.loadScriptOrderService();
    this.sourceProduct();
    this.partner();
    this.launchers();
    this.stbPurposes();
    this.fetchProductSales();
  }

  refreshPage() {
    this.ngOnInit();
  }

  sourceProduct() {
    this.restApi.GetProductsource().subscribe((data: any) => {
      this.data_productsource = data;
    });
  }
  partner() {
    this.restApi.GetViewnextsyspartnerless().subscribe((output: any) => {
      this.data_partner = output.data;
    });
  }
  partnerdtl() {
    let id = this.formOrderstb.value.partnerid;
    this.restApi.GetViewpartnerdetail(id).subscribe((output: any) => {
      this.partnerdetail = output.data;
    });
  }
  launchers() {
    let params = "?limit=1000&flagActive=1";
    this.restApi.GetPackages(params).subscribe((output: any) => {
      this.data_launchers = output.data;
    });
  }

  fetchProductSales() {
    return this.partnerService.PostListProduct({productsource: 5}).subscribe((output: any) => {
      this.data_products = output.data;
    })
  }

  stbPurposes() {
    this.restApi.GetStbPurposes().subscribe((output: any) => {
      this.data_stbpurpose = output.data;
    });
  }

  resetForm() {
    this.formProduct.reset();
  }

  redirectListorder(params: any) {
    this.router.navigate([params]);
  }

  submitOrderstbonly(el: HTMLElement) {
    console.dir(this.formOrderstb.value);
    this.restApi
      .PostCreateNextsysOrderstbonly(this.formOrderstb.value)
      .subscribe((data: any) => {
        this.response_api = data;
        if (this.response_api.status == true) {
          this.LoadJsOrder.loadScriptProductStb();
          this.alert_success = true;
          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth" });
          }, 500);

          this.alert_redirect = true;
          setTimeout(() => {
            this.redirectListorder("adminnextsys/listorder");
          }, 5000);
        } else {
          this.LoadJsOrder.loadScriptProductStb();
          this.alert_failed = true;
          setTimeout(() => {
            this.alert_failed = false;
          }, 6000);
        }
      });
  }
}
